import { comboboxOption } from "../../Components/InvoiceEditor/constants";
import ApiConfig from "../../Utils/Configs/apiConfig";

export const getAllCategoriesApi = async () => {
  try {
    const response = await ApiConfig.getInstance().get("/Category", {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
   
  } catch (error: any) {
    console.error("Error fetching categories:", error);
    throw error.response?.data || error.message;
  }
};

export const addCategoryApi = async (names: string[]) => {
  try {
    const response = await ApiConfig.getInstance().post(
      "/Category",
      {
        names: names,
      },
      {
        headers: {
          "Content-Type": "application/json",
          accept: "*/*",
        },
      }
    );
if(response.data?.data?.categoryId === null && response.data?.data?.name === null) {
  throw new Error("API did not return valid category data");
} 
  return { optionId: response.data.data[0].categoryId, optionName: response.data.data[0].name };
  } catch (error: any) {
    console.error("Error adding category:", error);
    throw error.response?.data || error.message;
  }
};